import { render, staticRenderFns } from "./Metrics.vue?vue&type=template&id=f74f9688&scoped=true&"
import script from "./Metrics.vue?vue&type=script&lang=ts&"
export * from "./Metrics.vue?vue&type=script&lang=ts&"
import style0 from "./Metrics.vue?vue&type=style&index=0&id=f74f9688&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f74f9688",
  null
  
)

export default component.exports